import Api from './xo_service';

export default {
    postTransaction(body) {
        return Api().post('/transactions',body)
    },
    getTransaction(id) {
        return Api().get(`/transactions/${id}`)
    }
}